import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import {
  FileInput,
  form,
  Form as AppForm
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { importParts } from "MODULES/parts/actions";
import { Warning } from "MODULES/shared/components";

const formName = "importPartsCSV";

function ImportPartsForm(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Warning>
            Please use the following column headers for the Parts CSV import:
            <br />
            <br />
            <strong>part_number</strong> (required field: unique identifier for
            the part. If the exact part number already exists, it will not be
            imported).
            <br />
            <strong>desc</strong> (optional field: description).
            <br />
            <strong>mfg</strong> (optional field: manufacturer).
            <br />
            <strong>application</strong> (optional field: system will
            auto-recognize and apply the appropriate Application Type [Engine,
            Aircraft, or APU]).
            <br />
            <strong>LLP</strong> (optional field: Life-Limited Part [Yes/No]).
            <br />
            <strong>cage</strong> (optional field: CAGE code).
            <br />
            <strong>eccn</strong> (optional field: Export Control Classification
            Number).
            <br />
            <strong>nsn</strong> (optional field: National Stock Number).
            <br />
            <strong>list_price</strong> (optional field: Manufacturer&apos;s
            List Price).
            <br />
            <strong>date_of_price</strong> (optional field: Date of Price).
            <br />
            <strong>country_of_mfg</strong> (optional field: Country of
            Manufacturing).
            <br />
            <strong>haz_mat</strong> (optional field: Hazardous Material
            [Yes/No]).
            <br />
            <strong>part_type</strong> (optional field: Rotable, Expendable, or
            Tooling).
            <br />
            <br />
            Ensure the import file is in .csv format.
          </Warning>
        </FormRow>
        <FormRow>
          <Col md={8}>
            <Field
              name="file"
              component={FileInput}
              label="Upload CSV File"
              required
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={8} mdOffset={2}>
            <a
              href="https://info-trader-assets.s3.us-east-2.amazonaws.com/public/InfoTrader_Standard_Import_Parts.csv"
              target="_blank"
              rel="noopener noreferrer"
            >
              Template
            </a>
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(importParts(data))
}))(
  form({
    form: formName
  })(ImportPartsForm)
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/CreateImportParts/ImportPartsForm.jsx